import { format } from 'date-fns-tz'

export const convertToLocalDateTime = (ISOStringDate: string) => {
  return format(new Date(ISOStringDate), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
}
